import { ICreditDTOOut, IDebitDTOOut, ITransferDTOOut, IUnloadDTOOut } from '../../interfaces/wallet.interface';
import { IUser } from '../../interfaces';

export class GetWallets {
    public static readonly type = '[Current user wallet] get';
    constructor(public studentId?: number) {}
}

export class CreditWallet {
    public static readonly type = '[Credit wallet]';
    constructor(public credit: ICreditDTOOut) {}
}

export class DebitWallet {
    public static readonly type = '[Debit wallet]';
    constructor(public debit: IDebitDTOOut) {}
}

export class UnloadWallet {
    public static readonly type = '[Unload wallet]';
    constructor(public unload: IUnloadDTOOut, public parentId: number) {}
}

export class TransferMoney {
    public static readonly type = '[Transfer money]';
    constructor(public transfer: ITransferDTOOut, public userToId: number) {}
}

export class ResetWallet {
    public static readonly type = '[Wallet] reset state';
}

export class GetParentWallet {
    public static readonly type = '[Get parent wallet] get';
    constructor(public parentId: number, public student: number|IUser, public forceRequest?: boolean) {}
}
